export default __webpack_public_path__ + "static/media/scc_titan_logoC_bottom.ac5c07da.png";